module.exports = __webpack_public_path__ + "media/images/photos/18-2d43dde088af8e01503441a0b9a682e7.jpg";